import { render } from "./UiPropBgColor.vue?vue&type=template&id=6c6d1eb6"
import script from "./UiPropBgColor.vue?vue&type=script&lang=js"
export * from "./UiPropBgColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__